import 'whatwg-fetch';
import { checkStatus } from './helper.js';

export function getUnresolvedIncidentCount() {
    return fetch('https://api.statuspage.io/v1/pages/lv1g23zm5qjc/incidents/unresolved', {
        headers: {
          Authorization: 'OAuth ATCTT3xFfGN0yr_P5DiRD-Z2gIYjHs84j2aTjoagrm74VT1Ndju29LNsseSxCd2sTPfnH8mIChDGAnfcKKUja3QWk2ZryBVvbArl0fze5o21nPIc2642VUZWk06vlEzR7nZwyA1ZPx3gO0BF1umr5xqDNg-XngFmzr83BwQJlf3qluULO_l7wv8=91163618'
        },
    }).then(checkStatus)
        .then(resp => resp.json())
}
